/* eslint-disable react/style-prop-object */
import React, { useEffect } from 'react';
import { useMatchesToday } from '../hooks/matches';
import { getMatchesPrefixedByKickOff } from '../utils/matches';
import TopMatch from '../components/MatchesToday/TopMatch';
import MatchRow from '../components/MatchesToday/MatchRow';

function MatchesToday() {
  const isMounted = React.useRef(false);
  const [matches, loading, error] = useMatchesToday();
  const [matchesToday, setMatchesToday] = React.useState(null);
  const [highlightedMatch, setHighlightedMatch] = React.useState(null);

  useEffect(() => {
    if (!isMounted.current && matches && !loading) {
      const matchesPrefixed = getMatchesPrefixedByKickOff(matches);
      setMatchesToday(matchesPrefixed);
      setHighlightedMatch(matches[0]);
      isMounted.current = true;
    }
  }, [matches, loading]);

  const markMatchAsHighlighted = (id) => {
    const match = matchesToday.find((m) => m.id === id);
    setHighlightedMatch(match);
  };

  const renderItem = (item) => {
    if (item?.isHeader) {
      return (
        <div className="col-12 px-2 px-sm-4 pt-2 pt-sm-3 data-container__row">
          <p className="badge badge--comp-pink">{item?.kickoff}</p>
        </div>
      );
    }

    return (
      <MatchRow
        match={item}
        markMatchAsHighlighted={markMatchAsHighlighted}
        highlight={item?.id === highlightedMatch.id}
      />
    );
  };

  if (!matchesToday || matchesToday?.length === 0) {
    return null;
  }

  return (
    <section className="row">
      <div className="col-12 d-flex d-lg-none justify-content-sm-center mb-3 mb-sm-5">
        <h2 className="heading-h6 heading-sm-h2">Dagens Matcher</h2>
      </div>
      <div className="col-12 col-lg-6 d-flex justify-content-center flex-column order-1 order-lg-0 pe-lg-0">
        <h2 className="heading-h2 mb-3 d-none d-lg-block px-4">
          Dagens Matcher
        </h2>
        <div className="data-container data-container--gradient">
          {matchesToday?.map((item) => renderItem(item))}
        </div>
      </div>
      {highlightedMatch && <TopMatch match={highlightedMatch} />}
    </section>
  );
}

export default MatchesToday;
